"use client";

import { usePathname } from "next/navigation";
import LemonsqueezyEventTracker from "@/components/LemonsqueezyEventTracker";
import LemonSqueezyScript from "@/components/LemonSqueezyScript";
import GTMTracker from "@/components/GTMTracker";
import LeadEventTracker from "@/components/LeadEventTracker";
import ConsentManager from "@/components/ConsentManager";
import XPixelTracker from "@/components/XPixelTracker";
import MetaPixelTracker from "@/components/MetaPixelTracker";
import PostHogTracker from "@/components/PostHogTracker";
import PostHogPageView from "@/components/PostHogPageView";
import GlobalErrorHandler from "@/components/GlobalErrorHandler";

export default function ClientTrackingComponents() {
  const pathname = usePathname();

  // Don't load tracking components for XML, API, text files, or other non-HTML routes
  const isXmlOrApiRoute =
    pathname?.includes(".xml") ||
    pathname?.includes(".txt") ||
    pathname?.includes(".json") ||
    pathname?.startsWith("/api/");

  if (isXmlOrApiRoute) {
    return null;
  }

  return (
    <>
      {/* 0. Global error handler - catches JS errors that could affect Googlebot */}
      <GlobalErrorHandler />

      {/* 1. ConsentManager MUST be first - sets up consent defaults */}
      <ConsentManager />

      {/* 2. GTMTracker - loads GTM with consent mode, listens for consent updates */}
      <GTMTracker />

      {/* 3. Event trackers - depend on dataLayer being available */}
      <LeadEventTracker />
      <LemonsqueezyEventTracker />

      {/* 4. Other tracking scripts - depend on consent state */}
      <XPixelTracker />
      <MetaPixelTracker />

      {/* 5. PostHog analytics - respects consent state */}
      <PostHogTracker />
      {/* 5a. Manual $pageview fan-out for App Router SPA navigations */}
      <PostHogPageView />

      {/* 6. LemonSqueezy script - independent, can load anytime */}
      <LemonSqueezyScript />
    </>
  );
}
